"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var numbersAscending = exports.numbersAscending = function numbersAscending(n1, n2) {
  return n1 - n2;
};
var numbersDescending = exports.numbersDescending = function numbersDescending(n1, n2) {
  return n2 - n1;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/sortUtil.js
// module id = 2297
// module chunks = 0